var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-footer"},[_c('div',{staticClass:"headingarea"},[_c('h4',{staticClass:"heading"},[_vm._t("heading"),_vm._v(" "),(_vm.badge)?_c('span',{staticClass:"badge"},[_c('badge-icon',{staticClass:"-md -requires"},[_vm._v(_vm._s(_vm.badge))])],1):_vm._e()],2)]),_vm._v(" "),_vm._t("text")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc1d708","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/StepFooter.vue
// module id = null
// module chunks = 